<template>
  <div>
    <md-field :class="{'input-error': $v.number.$error || formErrors.number.length}">
      <label>{{fieldDetails.number.text}}</label>
      <i class="fa fa-info-circle" v-if="fieldDetails.number.tooltip">
        <md-tooltip md-direction="top">{{fieldDetails.number.tooltip}}</md-tooltip>
      </i>
      <md-input v-model="number" @blur="$v.number.$touch(); checkSection()"
                ref="Number" />
    </md-field>
    <h6 class="error-message" v-if="$v.number.$error && !$v.number.required">Please enter Account Number</h6>
    <h6 class="error-message" v-else-if="$v.number.$error && !$v.number.accountNumber">Account Number should contain 1 to 34 alphanumeric characters</h6>
    <error-info v-else :errorList="formErrors.number" />

    <md-field :class="{'input-error': $v.ifsc.$error || errorMsg || formErrors.ifsc.length}">
      <label>{{fieldDetails.ifsc.text}}</label>
      <md-input v-model="ifsc" @blur="$v.ifsc.$touch()"
                maxlength="11" class="upper-case" />
    </md-field>
    <h6 class="error-message" v-if="$v.ifsc.$error && !$v.ifsc.required">Please enter IFSC Number</h6>
    <h6 class="error-message" v-else-if="$v.ifsc.$error && !$v.ifsc.validIfsc">Invalid IFSC Number. Please verify</h6>
    <h6 class="error-message" v-else-if="errorMsg">{{errorMsg}}</h6>
    <error-info v-else :errorList="formErrors.ifsc" />

    <ifsc-details :bankDetails="bankDetails" />
  </div>
</template>

<script>
import IfscDetails from '@/components/AccountSummary/IfscDetails'
import ErrorInfo from '@/components/global/ErrorInfo'

import ApiServices from '@/services/api/transfers'
import { requiredIf } from 'vuelidate/lib/validators'
import { validIfsc, accountNumber } from '@/utils/helpers/validators'

export default {
  name: 'BankDetails',
  components: { IfscDetails, ErrorInfo },
  data () {
    return {
      number: null,
      ifsc: '',
      bankDetails: {},
      errorMsg: null,
      formErrors: {
        number: [],
        ifsc: []
      }
    }
  },
  props: {
    index: Number,
    initialVals: Object,
    focus: {
      type: Boolean,
      default: true
    },
    fieldDetails: {
      default: () => {
        return {
          number: {
            text: 'Account Number',
            required: true
          },
          ifsc: {
            text: 'IFSC',
            required: true
          }
        }
      },
      type: Object
    }
  },
  validations () {
    return {
      number: {
        required: requiredIf(() => {
          return this.fieldDetails.number.required || this.ifsc
        }),
        accountNumber
      },
      ifsc: {
        required: requiredIf(() => {
          return this.fieldDetails.ifsc.required || this.number
        }),
        validIfsc
      }
    }
  },
  created () {
    this.$emit('setFunctions', this.setFunctions)
  },
  mounted () {
    if (this.focus) {
      this.$refs.Number.$el.focus()
    }
  },
  watch: {
    initialVals: {
      handler: 'populateData',
      immediate: true
    },
    ifsc (newVal, oldVal) {
      if (oldVal !== '') {
        this.bankDetails = {}
        this.errorMsg = null
      }

      if (newVal.length === 11 && Object.keys(this.bankDetails).length === 0 && validIfsc(newVal)) {
        this.ifscDetails()
      }
      this.formErrors.ifsc = []
    },
    number () {
      this.formErrors.number = []
    },
    '$v.number.$error' () {
      this.checkSection()
    },
    '$v.ifsc.$error' () {
      this.checkSection()
    }
  },
  methods: {
    setFunctions () {
      return {
        touchFields: () => {
          this.$v.$touch()
        },
        setErrors: (errors) => {
          this.formErrors = {
            ...this.formErrors,
            ...errors
          }
        },
        getErrors: () => {
          return {
            number: this.formErrors.number,
            ifsc: this.formErrors.ifsc
          }
        },
        isAnyErrors: () => {
          return this.$v.$error || this.errorMsg
        }
      }
    },
    populateData () {
      if (this.initialVals) {
        this.number = this.initialVals.number
        this.ifsc = this.initialVals.ifsc || ''
        this.bankDetails = {...this.initialVals.bank}

        if (this.initialVals.status === 'Invalid') {
          this.$v.$touch()
          this.errorMsg = this.initialVals.error
        }
      }
    },
    ifscDetails () {
      if (!this.$v.ifsc.$error) {
        ApiServices.ifscDetails(this.ifsc).then(response => {
          this.bankDetails = {...response.data}
          this.checkSection()
        }).catch(error => {
          this.errorMsg = error.body.message
          this.checkSection()
        })
      }
    },
    checkSection () {
      const account = {
        number: this.number,
        ifsc: this.ifsc.toUpperCase(),
        bank: this.bankDetails,
        error: this.errorMsg
      }
      let status = null

      if (this.$v.number.$error || this.$v.ifsc.$error || this.errorMsg) {
        status = 'FAILED'
      } else if (this.ifsc && this.number) {
        status = 'SUCCESS'
      } else {
        status = 'PENDING'
      }
      this.$emit('updateAccount', account, status, this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .upper-case {
    text-transform: uppercase;
  }

  .md-field {
    .fa-info-circle {
      margin-left: 8px;
      cursor: pointer;
      color: $primary;
    }
  }
</style>
